/* eslint-disable react/jsx-indent */
/* eslint-disable max-len */
/* eslint-env browser */
import React, { Component } from 'react';
import classNames from 'classnames';
import { imageUrlUtil } from '../Utils/otherUtils';

const placeholderImage = require('../Images/Placeholders/villaomr.png');
const houseImg = require('../Images/Icons/icon_house.svg');
const flatImg = require('../Images/Icons/icon_flat.svg');
const carImg = require('../Images/Icons/icon_car.svg');
const bicycleImg = require('../Images/Icons/icon_bicycle.svg');
const walkImg = require('../Images/Icons/icon_walk_grey.svg');
const arrowRightImg = require('../Images/Icons/icon_arrow_right.svg');
const busImg = require('../Images/Icons/icon_bus_grey.svg');

class AreaCardComponent extends Component {
  onFavClick() {
    const {
      areaFavOnClick,
      favourites,
      openArea,
    } = this.props;
    areaFavOnClick(favourites, openArea);
  }

  render() {
    const {
      Language: { text: { area, common: { close } } },
      navigationOnClick,
      closeOnClick,
      openArea: {
        name,
        thumbnail,
        isFav,
        housingType,
        housingPrices,
        commute: {
          driving, transit, bicycling, walking,
        },
      },
    } = this.props;

    const ConditionalRender = ({ cond, children }) => (cond ? children : null);

    return (
      <div className="area-card-container">
        <div className="wrapper">
          <div className="row collapse main-dividers top" style={{ backgroundImage: `url(${imageUrlUtil(thumbnail).thumb || placeholderImage})` }}>
            <div className="close-container">
              <button
                className="btn close-circle"
                id="close-btn"
                onClick={closeOnClick}
                aria-label={close}
              />
            </div>
            <button className="navigation-button" onClick={navigationOnClick}>
              <div className="row collapse name-container">
                <p>{name}</p>
                <img className="arrow" src={arrowRightImg} alt="arrow" />
              </div>
            </button>
          </div>
          <div className="row collapse main-dividers bottom">
            <div className="row collapse">
              <div className="link-container">
                <input
                  id="fav-btn"
                  type="button"
                  className={classNames('blue-link underline heart-icon', { filled: isFav })}
                  value={area.saveArea}
                  onClick={() => {
                    this.onFavClick();
                  }}
                />
              </div>
            </div>
            <div className="collapse mlr10">
              <ConditionalRender cond={housingType && housingType.includes(1) /* 1 = flat> */}>
                <div className="columns small-4 medium-12 column-container">
                  <div className="icon-container">
                    <img src={flatImg} alt="housing-price" />
                  </div>
                  <div className="text-container">
                    { /* TODO: Fix sq meter after adding feature toggle in admin */}
                    <p>{housingPrices && housingPrices.flatPrice ? `~ ${housingPrices.flatPrice.toLocaleString('sv-SE')} kr` : '-'}</p>
                  </div>
                </div>
              </ConditionalRender>

              <ConditionalRender cond={housingType && housingType.includes(2) /* 2 = house> */}>
                <div className="columns small-4 medium-12 column-container">
                  <div className="icon-container">
                    <img src={houseImg} alt="housing-price" />
                  </div>
                  <div className="text-container">
                    { /* TODO: Fix sq meter after adding feature toggle in admin */}
                    <p>{housingPrices && housingPrices.housePrice ? `~ ${housingPrices.housePrice.toLocaleString('sv-SE')} kr` : '-'}</p>
                  </div>
                </div>
              </ConditionalRender>

              <div className="columns small-4 medium-12 column-container">
                <div className="icon-container" >
                  <img src={carImg} alt="car" />
                </div>
                <div className="text-container">
                  <p>{driving.duration ? driving.duration.text : '-'}</p>
                </div>
              </div>

              <div className="columns small-4 medium-12 column-container">
                <div className="icon-container">
                  <img src={busImg} alt="bus" />
                </div>
                <div className="text-container">
                  <p>{transit.duration ? transit.duration.text : '-'}</p>
                </div>
              </div>

              <div className="columns small-4 medium-12 column-container">
                <div className="icon-container">
                  <img src={bicycleImg} alt="bicycle" />
                </div>
                <div className="text-container">
                  <p>{bicycling.duration ? bicycling.duration.text : '-'}</p>
                </div>
              </div>

              <div className="columns small-4 medium-12 column-container">
                <div className="icon-container">
                  <img src={walkImg} alt="walk" />
                </div>
                <div className="text-container">
                  <p>{walking.duration ? walking.duration.text : '-'}</p>
                </div>
              </div>

            </div>
            <div className="marker-container hide-for-small-only" />
          </div>
        </div>
      </div>
    );
  }
}

export default AreaCardComponent;



// WEBPACK FOOTER //
// ./src/Components/AreaCardComponent.js